// src/api/categoryApi.js
import api from '../shared/AxiosConfig';

export const categoryApi = {
    getCategories: () => api.get('/category/categories'),
    getCategoryBySlug: (slug) => api.get(`/category/${slug}`),
    createCategory: (data) => api.post('/category', data),
    updateCategory: (slug, data) => api.put(`/category/${slug}`, data),
    deleteCategory: (slug) => api.delete(`/category/${slug}`)
};
